export default __webpack_public_path__ + "static/media/BBB dark.6374dd3f.svg";